// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_6d-3";
export var contentContainer = "_6d-0";
export var editorContainer = "_6d-1";
export var quillInputForm = "_6d-2";
export var zoneDivider = "_6d-4";